// extracted by mini-css-extract-plugin
export default {"label":"Label_label__IbUSf","label_noInput":"Label_label_noInput__QWoJK"};